import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter} from "react-router-dom";
import _ from 'lodash';
import queryString from 'query-string';
import numberFormatter from "utils/numberFormatter";
import {
  IconButton, Dialog, DialogTitle, DialogContent,
  Button,
  Fade,
  Checkbox,
  DialogActions,
  Step,
  Radio,
  StepLabel, 
  Stepper,
  Grid,
} from "@material-ui/core";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import ModalLoanItem from './ChangeDealStatusModal/ModalLoanItem';
import PrimaryButton from 'components/Global/Buttons/PrimaryButton';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';
import NoQuotes from './ChangeDealStatusModal/NoQuotes';
import { seniorityMap } from "constants/loanSeniorityTypes";
const Spacer = styled.div`
  flex-grow:1;
`
const SelectedItemsNotification = styled.div`
  && {
    font-size:17px;  
    padding-left:20px;
    margin:0;
  }
`
const Description = styled.div`
  color: rgba(0, 0, 0, 0.537);
  padding-bottom:20px;
`;

const Error = styled.div`
  color:#ff0000;
  font-size:17px;
  padding-left:8px;
`

const StyledDialogActions = styled(DialogActions)`
  && {
    justify-content: flex-end;
  }
  `
const ExistingHeader = styled.div`
  color: #777777;
`;


const StepperContainer = styled.div`
width: 100%;
text-align: center;
vertical-align: middle;
`;
const StepperContainerInner = styled.div`
width: 75%;
display: inline-block;
text-align: center;
vertical-align: middle;
`;

class RefiCompareLoansModal extends Component {
  static DEFAULT_MAX_COUNT = 4;
  state = {
    activeStep: 0,
    shouldShowError:false,
    errorMessage: '',
    selectedLoanIds: [],
    useAggregateExisting: false,
    shouldShowExistingSection : true,
    activeStep : 0,
  }
  close = () => {
    this.setState({
      selectedLoanIds: [],
      shouldShowError: false,
      activeStep: 0,
    })
    this.props.onClose();
  }
  getSelectedCount = () => {
    return this.state.selectedLoanIds.length;
  }
  isMaxQuotesSelected = () => {
    return this.getSelectedCount() >= (this.props.maxCount || RefiCompareLoansModal.DEFAULT_MAX_COUNT)
  }
  showMaxQuotesSelectedError = () => {
    this.setState({
      shouldShowError:true,
      errorMessage: 'Only four quotes can be compared'
    })
  }
  showNotEnoughQuotesSelectedError = () => {
    this.setState({
      shouldShowError:true,
      errorMessage: 'Must select at least two quotes'
    })
  }
  select = (selectedLoanIdsCopy, id) => {
    selectedLoanIdsCopy.push(id);
    this.setState({
      shouldShowError:false,
      selectedLoanIds:selectedLoanIdsCopy
    })
  }
  deselect = (selectedLoanIdsCopy, index) => {
    selectedLoanIdsCopy.splice(index,1);
    this.setState({
      shouldShowError:false,
      selectedLoanIds:selectedLoanIdsCopy
    })
  }
  onToggle = (id) => {
    const {selectedLoanIds} = this.state;    
    const selectedLoanIdsCopy = [...selectedLoanIds];
    let index = _.findIndex(selectedLoanIds, x => x === id );
    if(index === -1 && this.isMaxQuotesSelected())
      this.showMaxQuotesSelectedError();
    else if(index === -1)
      this.select(selectedLoanIdsCopy,id);
    else 
      this.deselect(selectedLoanIdsCopy,index);
   
  }
  isSelected = (selectedLoanIds,id) => {
    return _.findIndex(selectedLoanIds,  x=> x === id) !== -1;
  }

  goToCompare = () => {
    const{selectedLoanIds} = this.state;    
    if(selectedLoanIds.length < 2){
      this.showNotEnoughQuotesSelectedError();
    }
    else {
     const {dealId} = this.props;
     let query = queryString.stringify(
       {
        loanId: selectedLoanIds.filter(x=>x!=="EXISTING_AGGREGATE"),
        methodName: "compare",
        useAggregateExisting: !!this.state.useAggregateExisting,
      },
      {
        arrayFormat: 'bracket'
      });    
     this.props.history.push(`/pipeline/deal/${dealId}/quote-comparison?${query}`);
    }
  }

  getInterestRateType = loan => {
    return loan["rateTypeRef.name"] || "N/A";
  };

  getLoanAmount = loan => {
    return numberFormatter.maskCurrency(loan.amount) || "N/A";
  };

  getTitleOfLoan = (loan) => {
    let output = ``;
    output += `${loan['loanProvider.name'] || "Lender Not Selected"} | `;
    output += `${this.getInterestRateType(loan)} | `;
    output += `${this.getLoanAmount(loan)}`;
    return output;
  }
  
  renderLoans = () => {   
    const {selectedLoanIds} = this.state;            
    return this.props.loans.map( x=> (
      <ModalLoanItem 
        key={x.id}
        toggle={this.onToggle} 
        loan={x} 
        isSelected={this.isSelected(selectedLoanIds, x.id)}/>
      )
    );
  }

  renderExistingLoans = () => {
    const {selectedLoanIds} = this.state;   
    const existing =  this.getExistingLoansOfSeniority();         
    existing.forEach(loan => {
      loan.title = this.getTitleOfLoan(loan);
    });
    return existing.map( x=> (
      <ModalLoanItem 
        key={x.id}
        toggle={this.onToggle} 
        loan={x} 
        isSelected={this.isSelected(selectedLoanIds, x.id)}/>
      )
    );
  }

  toggleUseAggregateExisting = () => {
    const newSetting = !this.state.useAggregateExisting;
    if(newSetting){
      let selected = this.state.selectedLoanIds;
      let existingIds = []
      this.getExistingLoansOfSeniority().forEach(loan => {
        existingIds.push(loan.id);
      })
      selected = _.difference(selected,existingIds);
      selected.push("EXISTING_AGGREGATE");
      this.setState({selectedLoanIds: selected});
    }else{
      let selected = this.state.selectedLoanIds;
      selected = selected.filter(x=>x!=="EXISTING_AGGREGATE");
      this.setState({selectedLoanIds: selected});
    }
    this.setState({useAggregateExisting: !this.state.useAggregateExisting});
  }

  getExistingLoansOfSeniority = (seniority) => {
    const {quoteType, closedLoanData} = this.props;
    if(!seniority) seniority = this.props.quoteType;
    // const closedLoanData = this.props.closedLoanData;
    if(!closedLoanData || !closedLoanData.data) return [];
    else {
      return closedLoanData.data.loans.filter(loan => {
        return loan.loanSeniorityId === seniorityMap[seniority] ||
                loan.loanSeniorityId === seniorityMap[quoteType] ||
                loan.loanSeniorityId === seniority
      });
    }
  }

  shouldDisplayAsSingleStage = () => {
    return this.getExistingLoansOfSeniority().length === 0;
  }

  renderExistingLoansSection = () => {
    if(!this.state.shouldShowExistingSection || this.getExistingLoansOfSeniority().length === 0) return null
    return (<>
    <hr/>
    <ExistingHeader>
      <div style={{display: "inline-block", width:"50%"}}>Choose Existing loans to compare:</div>
      <div style={{display:"inline-block", width:"50%", textAlign: "right", color:"black"}}>
        <Checkbox checked={this.state.useAggregateExisting} onClick={this.toggleUseAggregateExisting}/>
        <b>Use aggregate existing financing</b>
      </div>
    </ExistingHeader>
    {!this.state.useAggregateExisting &&
      <Grid container direction="row" spacing={8}>
        {this.renderExistingLoans()}
      </Grid>
    }
    </>)
  }
  
  renderStepComponent = () => {
    return (
      <StepperContainer>
        <StepperContainerInner>
          <Stepper style={{width:"100%"}} activeStep={this.state.activeStep} alternativeLabel>
            <Step key="first" >
              <StepLabel >
                Existing Financing
              </StepLabel>
            </Step>
              <Step key="second" >
                <StepLabel >
                  Choose Quotes
                </StepLabel>
              </Step>
          </Stepper>
        </StepperContainerInner>
      </StepperContainer>
    );
  }
  
  render() {
    
    const { shouldShowError,errorMessage} = this.state;
    const { isOpen, maxCount, quoteType, loans, closedLoanData } = this.props;
    const optionA = !this.shouldDisplayAsSingleStage();
    const optionB = (this.shouldDisplayAsSingleStage() || this.state.activeStep > 0);
    const optionC = !this.shouldDisplayAsSingleStage() && this.state.activeStep === 0;
    return (
      <Fragment>
        <Dialog open={isOpen} onClose={this.close} fullWidth maxWidth="md">
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between"
          >
            <DialogTitle>Compare {quoteType} Quotes</DialogTitle>
            <IconButton style={{ marginRight: 16 }} onClick={this.close}>
              <CloseIcon style={{ fontSize: 36 }} />
            </IconButton>
          </Grid>          
          <DialogContent>
            {optionA && this.renderStepComponent()}
            {optionB && 
              <>
                <Description>AAASelect up to four (4) quotes to compare:</Description>            
                {_.isEmpty(this.props.loans) && <NoQuotes/>}
                <Grid container direction="row" spacing={8}>
                  {this.renderLoans()}
                </Grid>
                {this.renderExistingLoansSection()}
              </>}
            {optionC && 
              <>
                <div style={{display:"inline-block"}}>
                  Would you like to include existing financing? 
                  <Radio checked = {this.state.shouldShowExistingSection} onClick={()=>this.setState({shouldShowExistingSection: true})}/>
                   Yes
                </div>
                <div style={{display:"inline-block"}}>
                  <Radio checked = {!this.state.shouldShowExistingSection} onClick={()=>this.setState({shouldShowExistingSection: false})}/>
                   No
                </div>
              </>
            }
          </DialogContent>
          {(this.shouldDisplayAsSingleStage() || this.state.activeStep > 0) &&
            <StyledDialogActions>
              <SelectedItemsNotification>{this.getSelectedCount(loans)}/{maxCount || RefiCompareLoansModal.DEFAULT_MAX_COUNT} Selected</SelectedItemsNotification>
              <Fade in={shouldShowError}>
                <Error>{errorMessage}</Error>
              </Fade>
              <Spacer></Spacer>
              <Fragment>
                <SecondaryButton onClick={this.close}>Cancel</SecondaryButton>
                <SecondaryButton onClick={()=>this.setState({activeStep:0})}>Back</SecondaryButton>
                <PrimaryButton disabled={_.isEmpty(this.props.loans)} onClick={this.goToCompare}>Go To Compare</PrimaryButton>
              </Fragment>
            </StyledDialogActions>
          }
          {(!this.shouldDisplayAsSingleStage() && this.state.activeStep === 0) &&
            <StyledDialogActions>
              <Fragment>
                <SecondaryButton onClick={this.close}>Cancel</SecondaryButton>
                <PrimaryButton onClick={()=>this.setState({activeStep:1})}>Next</PrimaryButton>
              </Fragment>
            </StyledDialogActions>
          }
        </Dialog>
      </Fragment>
    )
  }
}


const mapStateToProps = ({loan}) => {
  return ({
  closedLoanData: loan.loansByPreference.closedLoans || {},
})};

export default compose(
  connect(
  mapStateToProps,
  {

  }
))(RefiCompareLoansModal);

